<template>
    <div class="erm_wrapper">

        <AppModal :title="'Add New Table Item'" :width="700" :showFooter="false" ref="add_table_modal">
            <template #body>
              <AddTable @updateDataAfterNewAdd="updateDataAfterNewAdd" />
            </template>
        </AppModal>

        <AppTable :tableData="tables" v-loading="loading">
            <template #header>
                <h1 class="table-title">All Table Item</h1>
                <el-button @click="OpenMenuAddModal()" size="large" type="primary" icon="Plus" class="ltm_button">
                    Add New Table Item
                </el-button>
            </template>

            <template #filter>
                <el-input class="easyRestaurantManager-search-input erm_input" v-model="search" style="width: 240px" size="large"
                    placeholder="Please Input" prefix-icon="Search" />
            </template>

            <template #columns>
                <el-table-column prop="id" label="ID" width="60" />
                <el-table-column prop="table_number" label="Table Number" width="auto" />
                <el-table-column prop="branch_id" label="Branch Id" width="auto" />
                <el-table-column prop="capacity" label="Capacity" width="auto" />
                <el-table-column prop="status" label="Status" width="auto" />
                <el-table-column label="Operations" width="120">
                    <template #default="{ row }">
                        <el-tooltip class="box-item" effect="dark" content="Click to edit tables" placement="top-start">
                            <el-button @click="openUpdateTableModal(row)" class="erm_box_icon" link size="small">
                                <Icon icon="easyRestaurantManager-edit" />
                            </el-button>
                        </el-tooltip>
                        <el-tooltip class="box-item" effect="dark" content="Click to delete tables"
                            placement="top-start">
                            <el-button @click="openDeleteTableModal(row)" class="erm_box_icon" link size="small">
                                <Icon icon="easyRestaurantManager-delete" />
                            </el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </template>

            <template #footer>
                <el-pagination v-model:current-page="currentPage" v-model:page-size="pageSize"
                    :page-sizes="[10, 20, 30, 40]" large :disabled="total_table <= pageSize" background
                    layout="total, sizes, prev, pager, next" :total="+total_table" />
            </template>

        </AppTable>

        <AppModal :title="'Update Table Data'" :width="800" :showFooter="false" ref="update_table_modal">
            <template #body>
                <AddTable :tables_data="table" />
            </template>
        </AppModal>

        <AppModal :title="'Delete Table'" :width="500" :showFooter="false" ref="delete_table_modal">
            <template #body>

                <div class="delete-modal-body">
                    <h1>Are you sure ?</h1>
                    <p>You want to delete this table</p>
                </div>
            </template>
            <template #footer>
                <div class="easyRestaurantManager-modal-footer">
                    <el-button @click="$refs.delete_table_modal.handleClose()" type="default"
                        size="medium">Cancel</el-button>
                    <el-button @click="deleteTable" type="primary" size="medium">Delete</el-button>
                </div>
            </template>
        </AppModal>

    </div>
</template>

<script>
import axios from 'axios';

import AppTable from "../../components/AppTable.vue";
import Icon from "../../components/Icons/AppIcon.vue";
import AppModal from "../../components/AppModal.vue";
import AddTable from "./AddTables.vue"
export default {
    components: {
        AppTable,
        Icon,
        AppModal,
        AddTable,
    },
    data() {
        return {
            search: '',
            tables: [],
            table: {},
            total_table: 0,
            loading: false,
            add_table_modal: false,
            currentPage: 1,
            pageSize: 10,
            active_id: null,
            rest_api: window.RestaurantMenuMangeData.rest_api,
        }
    },
    methods:{
       
        OpenMenuAddModal(){
            this.$refs.add_table_modal.openModel();
        },

        async getTable(){
            this.loading = true;
            try {
                const response = await axios.get(`${this.rest_api}/getTable`);
                this.tables = response.data?.tables;
                this.loading = false;
            } catch (error) {
                this.loading = false;
                console.error('Error fetching couriers:',);
            }
        },

        openDeleteTableModal(row) {
            this.active_id = row.id;
            this.$refs.delete_table_modal.openModel();
        },
        async deleteTable() {
            try {
                const response = await axios.post(`${this.rest_api}/deleteTable`, { id: this.active_id });
                this.getTable();
                this.$refs.delete_table_modal.handleClose();
            } catch (error) {
                console.error('Error fetching couriers:',);
            }
        },
      
        openUpdateTableModal(row) {
            this.table = row;
            this.$refs.update_table_modal.openModel();
        },
        updateDataAfterNewAdd(new_table) {
            this.$refs.add_table_modal.handleClose();
            this.tables.unshift(new_table);
        },
       
    },
    mounted(){
            this.getTable();
    }


}
</script>